<div class="slide slide--cover">
	<!-- Decorative soft blobs (LOLLY Figma 13302:100245/100246), clipped by the
	     slide's overflow:hidden so only the on-card arc shows. -->
	<span class="slide--cover__blob slide--cover__blob--blue"></span>
	<span class="slide--cover__blob slide--cover__blob--pink"></span>

	<div class="slide--cover__top">
		<div class="slide--cover__eyebrow">{{ eyebrowText }}</div>

		<h1
			class="slide--cover__title"
			[style.--cover-hero-size]="heroFontSizePx"
		>
			<!-- In the editor the hero is typed into where it stands; it is
			     drawn two-tone again as soon as the reader stops. -->
			<app-report-inline-text
				*ngIf="editorMode; else heroTitle"
				[text]="title"
				[head]="titleHead"
				[accent]="titleAccent"
				[field]="textFields.title"
				[editorMode]="editorMode"
			></app-report-inline-text>
			<ng-template #heroTitle>
				{{ titleHead }}
				<span class="slide--cover__title-accent">
					{{ titleAccent }}
				</span>
			</ng-template>
		</h1>

		<p *ngIf="description" class="slide--cover__subtitle">
			<app-report-inline-text
				[text]="description"
				[field]="textFields.body"
				[editorMode]="editorMode"
				[flagsBelow]="false"
			></app-report-inline-text>
		</p>
		<!-- EDITOR ONLY: outside the paragraph, whose clamp would clip them. -->
		<app-report-figure-flags
			*ngIf="editorMode && description"
			place="cover:description"
		></app-report-figure-flags>
	</div>

	<div class="slide--cover__footer">
		<div class="slide--cover__period" *ngIf="dateLabel">
			<div class="slide--cover__period-label">{{ periodLabel }}</div>
			<div class="slide--cover__period-value">{{ dateLabel }}</div>
		</div>

		<app-report-slide-brand class="slide--cover__powered" [cover]="true">
			Powered by
			<strong>lolly</strong>
		</app-report-slide-brand>
	</div>
</div>
